import * as DTOS from "../FeralScan.dtos";

export interface IBaseUserGroupActions {
    type: string;
}

export interface IGetUserGroupRequestAction extends IBaseUserGroupActions {
    userGroupId: number;
}

export interface IGetUserGroupSuccessAction extends IBaseUserGroupActions {
    userGroup: DTOS.UserGroup;
}

export const
    GET_USER_GROUP_REQUEST = "GET_USER_GROUP_REQUEST",
    GET_USER_GROUP_SUCCESS = "GET_USER_GROUP_SUCCESS";

export function getUserGroupRequest(groupId: number): IGetUserGroupRequestAction {
    return {
        type: GET_USER_GROUP_REQUEST,
        userGroupId: groupId
    };
}

export function getUserGroupRequestSuccess(response: DTOS.UserGroup): IGetUserGroupSuccessAction {
    return {
        type: GET_USER_GROUP_SUCCESS,
        userGroup: response
    };
}